<template>
  <div class="help-container">
    <div class="main">
      <p class="main-title">帮助中心</p>

      <div v-show="!list || !list.length" class="nothing-box" style="margin-top: -100px">
        <i class="not-icon" />
        <p class="not-tit">暂无内容</p>
      </div>
      <div class="infinite-list" v-infinite-scroll="load" style="overflow: auto">
        <el-collapse v-if="list && list.length" class="main-collapse" accordion>
          <el-collapse-item v-for="(v, i) in list" :key="i" :title="v.title">
            <p v-html="v.content"></p>
          </el-collapse-item>
        </el-collapse>
        <div v-else class="nothing-box pt80 pb40">
          <i class="not-icon" />
        </div>
      </div>
    </div>
    <div class="footer-info">
      <div class="footer-tip">
        <p>没找到想要的答案？</p>
        <p>您还可以通过右侧方式咨询我们</p>
      </div>
      <div class="footer-way">
        <p>服务热线</p>
        <p>13360041874</p>
        <p>工作日: 9:00-18:00</p>
      </div>
      <div class="footer-image">
        <img src="~@/assets/image/contact/img_qrcode_kefu@2x.png" />
        <div>
          <p>微信客服</p>
          <p>微信扫码联系客服</p>
        </div>
      </div>
    </div>
    <!-- <div class="fd">
      <p class="fd-title bold">联系我们</p>
      <p class="fd-tip">没找到想要的答案？您还可以通过以下方式咨询我们</p>
      <div class="fd-content">
        <div class="content-item">
          <p class="item-title">服务热线</p>
          <span class="item-tip mb30">TELEPHONE</span>
          <div class="item-blue">{{ info.line || '' }}</div>
        </div>
        <div class="content-item">
          <p class="item-title">联系邮箱</p>
          <span class="item-tip mb30">E-MAIL</span>
          <div class="item-blue" style="font-size:16px">{{ info.server || '' }}</div>
        </div>
        <div class="content-item">
          <div class="item-img">
            <img :src="info.qrcode" />
          </div>
          <span class="item-tip mt12">扫描二维码添加壹卷客服微信</span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNames: "",
      list: [],
      info: {},
    };
  },
  methods: {
    init() {
      this.getHelList();
      this.getHelInfo();
    },
    // 获取帮助列表
    getHelList() {
      this.$api.system
        .getHelpList({
          page: 1,
          perPage: 9999,
        })
        .then((res) => {
        
          
          this.list = res.items;
        });
    },
    // 获取帮助信息
    getHelInfo() {
      this.$api.system.getHelpInfo().then((res) => {
        let info = {};

        res.forEach((v) => {
          info[v.key] = v.value;
        });

        this.info = info;
      });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.infinite-list{
  height:570px;
}
.help-container {
  height: 100%;
  background: #fff;
  padding: 24px;
  border-radius: 16px;
  .main {
    min-height: calc(100% - 124px);
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0;
    }
    &-title {
      color: $primary_title;
      font-weight: 500;
      line-height: 28px;
      font-size: 20px;
    }
    &-collapse {
      border: none;
      padding: 16px 0;
      ::v-deep .el-collapse-item {
        &:not(:last-child) {
          margin-bottom: 8px;
        }
        border: 1px solid #f3f4f5;
        border-radius: 8px;
        padding: 22px 16px;
        .el-collapse-item__header {
          height: 24px;
          line-height: 24px;
          font-size: 16px;
          color: $primary_title;
          border: none;
          background: transparent;
          &:before {
            content: "";
            display: block;
            width: 24px;
            height: 24px;
            background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAaVBMVEUAAAD1qT31qzv0qTz0qT32qj/yqjv0qT30qT3////+/fv0rET0rkj++/b98+P2u2b1tlr+9+74zpH4zY73wnb3wXP2v2/99Of87tr86tD76Mv75sf63LD4z5X2u2f1s1P63rb3yIT3x4MrT4uvAAAACHRSTlMA4kn5izknzBdeX8wAAACXSURBVCjPnZHZDoMgEEWr3WZYBBRs1apt//8ji5PUBMTEcF9uhhNmPWWoLCBSURKg94gQgIQOAq6TQD0Zsl5vgGNVY0cjdQR49RDeZjlQeFuBwpr8hWKxywq+2JLXqBY7X//gQ4BDgxPF9yDVbCyloh9B8beUPYQ1wPp23ciwDbvymvyA2JkhuRIBruMEcrabPtT+aXP0AwSKD3oJFadzAAAAAElFTkSuQmCC");
            background-size: 100%;
            margin-right: 7px;
          }
          &.is-active {
            // color: $primary;
          }
          .el-collapse-item__arrow {
            width: 16px;
            height: 16px;
            line-height: 14px;
            border: 1px solid #c3cfd9;
            border-radius: 50%;
            text-align: center;
            // transform: scale(0.8);
            font-size: 8px;
            color: $primary;
          }
        }
        .el-collapse-item__wrap {
          border: none;
          .el-collapse-item__content {
            padding-top: 9px;
            font-weight: 400;
            color: #9aaab7;
            line-height: 24px;
            font-size: 12px;

            display: flex;
            align-items: flex-start;
            &:before {
              content: "";
              display: block;
              width: 24px;
              height: 24px;
              background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAb1BMVEUAAAAAav8Aaf8Aaf8Aav8Aa/8Aaf8Aav8Aav/////q8//d6//I3/9+s//3+v/0+P/Z6P+Ft/9sqf9kpP9JlP8ffP8Qc//h7f/O4v+/2f++2f+ozP+iyP+Xwv+Mu/99sv9doP9QmP9BkP87jP8qgv/FJjOCAAAACHRSTlMA4kn5izknzBdeX8wAAAB+SURBVCjPpdFHDoQwDAXQgWn5KfTe2/3PiIICQlbYwN9E9lOUyH7diOswEsfdQPepbMAseQgDhB1KD5MNUvS82eF3ghBp62em+Jwgr9iM2BTv7wGJbgrJTP4H1BBB4GOhNzJPKqVCdPSNCIk+JKe/Krjx8emsaC4Xdb3aO1kB/HcOetfK6FYAAAAASUVORK5CYII=");
              background-size: 100%;
              margin-right: 7px;
              background-repeat: no-repeat;
            }
            > p {
              width: calc(100% - 31px);
            }
          }
        }
      }
    }
  }
  .footer-info {
    height: 110px;
    display: flex;
    align-items: center;
    background-image: url("data:image/png;base64,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");
    background-repeat: no-repeat;
    background-size: 100%;
    padding: 0 32px;
    margin-top: 16px;
    .footer-tip {
      flex: 2;
      > p:first-child {
        font-size: 16px;
        color: $primary_title;
        font-weight: 500;
        line-height: 22px;
        margin-bottom: 6px;
      }
      > p:last-child {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9aaab7;
        line-height: 22px;
      }
    }
    .footer-way {
      flex: 3;
      text-align: left;
      > p:first-child {
        font-weight: 500;
        color: #60707d;
        line-height: 22px;
        font-size: 14px;
      }
      > p:nth-child(2) {
        font-weight: 500;
        color: $primary_title;
        line-height: 22px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      > p:last-child {
        font-weight: 400;
        color: #9aaab7;
        line-height: 22px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
      }
    }
    .footer-image {
      display: flex;
      > img {
        width: 56px;
        height: 56px;
        margin-right: 16px;
      }
      > div {
        padding: 4px 0 0;
        > p:first-child {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #60707d;
          line-height: 22px;
        }
        > p:last-child {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #9aaab7;
          line-height: 22px;
          margin-top: 5px;
        }
      }
    }
  }
  .fd {
    padding: 50px 200px 80px;
    background: #f8fafb;
    &-title {
      font-size: 30px;
      color: $primary_title;
      text-align: center;
      margin-bottom: 8px;
    }
    &-tip {
      font-size: 18px;
      color: $tertiary_text;
      text-align: center;
      margin-bottom: 42px;
    }
    &-content {
      display: flex;
      justify-content: space-between;
      .content-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 263px;
        height: 215px;
        background: #ffffff;
        box-shadow: 0px 8px 20px 0px rgba(139, 156, 191, 0.2);
        border-radius: 2px;
        .item-title {
          font-size: 20px;
          color: $primary_text;
        }
        .item-tip {
          font-size: 16px;
          color: $placeholder;
        }
        .item-blue {
          width: 200px;
          height: 40px;
          background: $primary;
          border-radius: 4px;
          text-align: center;
          line-height: 40px;
          font-size: 18px;
          color: #fff;
        }
        .item-img {
          width: 100px;
          height: 100px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
